import { Component, DestroyRef, inject, Inject, OnInit , signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { skip } from 'rxjs/operators';
import { SettingsService } from 'src/app/services/account/settings.service';
import { SpeechService } from 'src/app/services/media/speech.service';

@Component({
  standalone: true,
  selector: 'app-voice-command-listen-dialog',
  templateUrl: './voice-command-listen-dialog.component.html',
  styleUrls: ['./voice-command-listen-dialog.component.scss']
})
export class VoiceCommandListenDialogComponent implements OnInit {

  public readonly recognizedCommand = signal<{ sentences: string, confidence: number }>({
    sentences: "Say something...",
    confidence: 0
  });

  constructor(
    public dialogRef: MatDialogRef<VoiceCommandListenDialogComponent>,
    public settingsService: SettingsService,
    private readonly speechService: SpeechService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.speechService.ObservableTestRecognizedVoiceCommand.pipe(skip(1), takeUntilDestroyed(this.destroyRef)).subscribe((resp) => {
      if (resp) {
        this.recognizedCommand.set(resp);
      }
    })

    setTimeout(() => {
      this.dialogRef.close();
    }, 5000);
  }
}
